import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { DateService } from '@app/services';
import { DatePipe } from '@angular/common';

@Component({
    selector: "time-span-display",
    templateUrl: "./time-span-display.component.html",
    styleUrls: ["./time-span-display.component.less"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DatePipe]
})
export class TimeSpanDisplayComponent implements OnInit {
  private readonly _componentName = 'TimeSpanDisplayComponent';
  private _startDate: Date = new Date();
  private _endDate: Date = new Date();

  public showYearMonthDay = false;

  @Input()
  public toolTip = '';

  /**
   * 🡺 🠮 🡆 ➠ 🠶
   */
  @Input()
  public dateTimeSeparator = ' ➠ ';

  /**
   * Prefix Separator
   */
  @Input()
  public prefixSeparator = ' - ';

  /**
   * A max 3-character code to prefix the timespan display
   */
  @Input("prefix")
  public prefixCode = null;

  constructor(private dateHelper: DateService) {
    this.startDate = new Date();

    this.endDate = this.dateHelper.addSeconds(this.startDate, 7200);

    //     this.endDate = this.dateHelper.addDays(this.dateHelper.addSeconds(this.startDate, 7200), 1);
  }

  ngOnInit() {}

  public get startDate(): Date {
    return this._startDate;
  }

  @Input()
  public set startDate(v: Date) {
    this._startDate = v;
    this.onDatesChanged();
  }

  public get endDate(): Date {
    return this._endDate;
  }

  @Input()
  public set endDate(v: Date) {
    this._endDate = v;
    this.onDatesChanged();
  }

  /**
   * Handles when either the start or end date changes and they need
   * to be compared to one another
   */
  private onDatesChanged() {
    console.log(`${this._componentName}.onDatesChanged() `);
    var b = false;

    if (this.startDate && this.endDate) {
      if (
        !this.dateHelper.isDateEqual(this.startDate, this.endDate) ||
        this.dateHelper.getHoursBetween(this.startDate, this.endDate) > 24
      ) {
        b = true;
      }
    }

    if (this.showYearMonthDay !== b) {
      this.showYearMonthDay = b;
    }
  }
}
